import { render } from "./CreateSubject.vue?vue&type=template&id=22d28e92"
import script from "./CreateSubject.vue?vue&type=script&lang=js"
export * from "./CreateSubject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__